import { render, staticRenderFns } from "./NaviTab.vue?vue&type=template&id=c223f1e8&scoped=true"
import script from "./NaviTab.vue?vue&type=script&lang=js"
export * from "./NaviTab.vue?vue&type=script&lang=js"
import style0 from "./NaviTab.vue?vue&type=style&index=0&id=c223f1e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c223f1e8",
  null
  
)

export default component.exports